<template>
    <div class="left-banner_ext" />
</template>
<script>
export default {};
</script>
